export function getTextColorForBackground(hexColor: string): string {
	// Remove # if present
	const hex = hexColor.replace("#", "");

	// Convert hex to RGB
	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);

	// Calculate luminance using relative luminance formula
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

	if (luminance > 0.6) {
		// If the color is light, return a darker version of the same color
		const factor = 0.4; // 0 = black, 1 = original
		const darken = (c: number) => Math.max(0, Math.floor(c * factor));
		const dr = darken(r).toString(16).padStart(2, "0");
		const dg = darken(g).toString(16).padStart(2, "0");
		const db = darken(b).toString(16).padStart(2, "0");
		return `#${dr}${dg}${db}`;
	} else {
		// If the color is dark, return white
		return "#ffffff";
	}
}
